<template>
	<div class="profile">
		<md-card>
			<md-card-header>
				<div class="md-title">{{$t("profile")}}</div>
			</md-card-header>

			<md-card-content>
				<div class="avatar">
					<img :src="profile.avatar">
				</div>

				<md-input-container>
					<label>{{$t("admin.image")}}</label>
					<md-file id="fileInput"></md-file>
				</md-input-container>

				<div class="row">
				<md-input-container class="col-md-6">
					<label>{{$t("name")}}</label>
					<md-input v-model="profile.name"></md-input>
				</md-input-container>
					<md-input-container v-if="profile.doctorData" class="col-md-6">
						<label>{{$t("admin.healthcareId")}}</label>
						<md-input v-model="profile.doctorData.healthcareId"></md-input>
					</md-input-container>
				</div>

				<!--
				<md-checkbox v-model="profile.doctorData.public">Publikus web profil</md-checkbox>
				<p class="description">
					Ha ez be van kapcsolva, a profilon megadott adatokat a weboldalunk látogatói is elérhetik, ezzel megkönnyítve a kapcsolatfelvételt Önnel. Ettől függetlenül a mobil alkalmazásban bármikor elérhetik az adatait a páciensek, tehát csak olyan információt adjon meg, amit meg szeretne osztani másokkal.
				</p>
			-->

			<p class="description">
				<p class="desc">{{$t("admin.descinfo")}}</p>

				<div class="row">
					<md-input-container v-if="profile.doctorData" class="col-md-6">
						<label>{{$t("admin.discipline")}}</label>
						<md-input v-model="profile.doctorData.speciality"></md-input>
					</md-input-container>
					<md-input-container v-if="profile.doctorData" class="col-md-6">
						<label>{{$t("attributes")}}</label>
						<md-input v-model="profile.doctorData.specification"></md-input>
					</md-input-container>
				</div>

				<div class="row">
					<md-input-container v-if="profile.doctorData" class="col-md-6">
						<label>{{$t("admin.facebook_link")}}</label>
						<md-input v-model="profile.doctorData.facebookPageUrl"></md-input>
					</md-input-container>
					<md-input-container v-if="profile.doctorData" class="col-md-6">
						<label>{{$t("admin.website")}}</label>
						<md-input v-model="profile.doctorData.website"></md-input>
					</md-input-container>
				</div>
				<p class="desc">Publikus Facebook oldal megadásával a páciensek a Pulmoment alkalmazásán keresztül is olvashatják a Facebookon megosztott híreit.</p>

				<md-input-container v-if="profile.doctorData">
					<label>{{$t("introduction")}}</label>
					<md-textarea v-model="profile.doctorData.introduction"></md-textarea>
				</md-input-container>
			</md-card-content>

			<md-card-actions>
				<md-button v-on:click="save()" class="md-primary">{{$t("admin.save")}}</md-button>
			</md-card-actions>
		</md-card>

		<md-card>
			<md-card-header>
				<div class="md-title">{{$t("contact")}}</div>
			</md-card-header>

			<md-card-content v-if="profile.doctorData">
				<div v-for="contact of profile.doctorData.contact" class="row">
					<md-input-container class="col-md-5">
						<label>{{$t("contact_name")}}</label>
						<md-input v-model="contact.name"></md-input>
					</md-input-container>
					<md-input-container class="col-md-5">
						<label>{{$t("contact_data")}}</label>
						<md-input v-model="contact.value"></md-input>
					</md-input-container>
					<md-button class="md-warn" v-on:click="deleteContact(contact)">Törlés</md-button>
				</div>
			</md-card-content>

			<md-card-actions>
				<md-button v-on:click="newContact()" class="md-primary">{{$t("admin.add_new")}}</md-button>
				<md-button v-on:click="save()" class="md-primary">{{$t("admin.save")}}</md-button>
			</md-card-actions>
		</md-card>
	</div>
</template>

<script>
	import Api from '../../../generated'
	import _ from 'lodash'

	export default {
		data(){
			return {
				profile: {}
			}
		},
		methods: {
			reload: function(){
				Api.ApiClient.instance.profile((error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						this.profile = data['data'];
					}
				});
			},
			save: function(){
				Api.ApiClient.instance.updateProfile(this.profile, (error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						if(document.getElementById('fileInput').files.length > 0){
							Api.ApiClient.instance.uploadAvatar(document.getElementById('fileInput').files[0], (error, data, response) => {
								if (error) {
									console.error(error);
								} else {
									this.$bus.$emit('showToast','Sikeres mentés', 'info');
									console.log(response);
									this.reload();
								}
							});
						} else {
							this.$bus.$emit('showToast','Sikeres mentés', 'info');
							this.reload();
						}
					}
				});
			},
			deleteContact: function(contact){
				this.profile.doctorData.contact = _.pull(this.profile.doctorData.contact, contact);
				/* To update changes */
				this.profile.doctorData.contact.push({});
				this.profile.doctorData.contact.pop();
			},
			newContact: function(){
				this.profile.doctorData.contact.push({
					name: "",
					value: ""
				});
			}
		},
		mounted(){
			this.reload();
		}
	}
</script>

<style scoped>
	.avatar{
		width: 128px;
		height: 128px;
		background-color: #eee;
		margin-bottom: 16px;
	}
	.row{
		margin: 8px;
	}
</style>



// WEBPACK FOOTER //
// Profile.vue?25a2d0d4